/*
 * CommunityPermissions Messages
 *
 * This contains all the text for the CommunityPermissions component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  community: {
    id: 'app.components.AppPermissions.community',
    defaultMessage: 'Community',
  },
  optionsHelp: {
    id: 'app.components.AppPermissions.optionsHelp',
    defaultMessage: 'Options for Permissions',
  },
  students: {
    id: 'app.components.UsersByRole.student',
    defaultMessage: 'Students',
  },
  parents: {
    id: 'app.components.UsersByRole.parent',
    defaultMessage: 'Parents',
  },
  employees: {
    id: 'app.components.UsersByRole.employee',
    defaultMessage: 'Employees',
  },
  staff: {
    id: 'app.components.UsersByRole.staff',
    defaultMessage: 'Staff Members',
  },
  defaultPermissions: {
    id: 'app.components.AppPermissions.defaultPermissions',
    defaultMessage: 'Default Permissions',
  },
  permissions: {
    id: 'app.components.AppPermissions.permissions',
    defaultMessage: 'Permissions',
  },
  exceptions: {
    id: 'app.components.AppPermissions.exceptions',
    defaultMessage: 'Exceptions',
  },
  readOnly: {
    id: 'app.components.AppPermissions.readOnly',
    defaultMessage: 'Read Only',
  },
  readOnlyHelp: {
    id: 'app.components.AppPermissions.readOnlyHelp',
    defaultMessage: 'User can only read messages in this group. User can respond to registration forms with events.',
  },
  readLike: {
    id: 'app.components.AppPermissions.readLike',
    defaultMessage: 'Read and Like',
  },
  readLikeHelp: {
    id: 'app.components.AppPermissions.readLikeHelp',
    defaultMessage: 'In addition to the above, user can also like posts',
  },
  readCommentLike: {
    id: 'app.components.AppPermissions.readCommentLike',
    defaultMessage: 'Read, Comment, and Like',
  },
  readCommentLikeHelp: {
    id: 'app.components.AppPermissions.readCommentLikeHelp',
    defaultMessage: 'User can like and respond to posts.',
  },
  write: {
    id: 'app.components.AppPermissions.write',
    defaultMessage: 'Write',
  },
  writeHelp: {
    id: 'app.components.AppPermissions.writeHelp',
    defaultMessage: 'In addition to reading, liking and responding to posts, user can also write posts and add events to this group.',
  },
  moderate: {
    id: 'app.components.AppPermissions.moderate',
    defaultMessage: 'Moderate',
  },
  moderateHelp: {
    id: 'app.components.AppPermissions.moderateHelp',
    defaultMessage: 'User can edit and remove posts, responses and events from others.',
  },
  noExceptions: {
    id: 'app.components.AppPermissions.noExceptions',
    defaultMessage: 'No members with custom permissions',
  },
  addException: {
    id: 'app.components.AppPermissions.addException',
    defaultMessage: 'Add Exceptions',
  },
  conversations: {
    id: 'app.components.AppPermissions.conversations',
    defaultMessage: 'Conversations',
  },
  conversationsHelp: {
    id: 'app.components.AppPermissions.conversationsHelp',
    defaultMessage: 'Start conversations with individual members in this group',
  },
  personalMessages: {
    id: 'app.components.AppPermissions.personalMessages',
    defaultMessage: 'Personal Messages',
  },
  personalMessagesHelp: {
    id: 'app.components.AppPermissions.personalMessagesHelp',
    defaultMessage: 'Send a message to one or more members of your groups',
  },
  topics: {
    id: 'app.components.AppPermissions.topics',
    defaultMessage: 'Conversations',
  },
  topicsHelp: {
    id: 'app.components.AppPermissions.topicsHelp',
    defaultMessage: 'Start conversations with one or more members in your groups',
  },
  toNone: {
    id: 'app.components.AppPermissions.toNone',
    defaultMessage: 'None',
  },
  toEmployees: {
    id: 'app.components.AppPermissions.toEmployees',
    defaultMessage: 'To Employeees',
  },
  toAllMembers: {
    id: 'app.components.AppPermissions.toAllMembers',
    defaultMessage: 'To All Members',
  },
  withNone: {
    id: 'app.components.AppPermissions.withNone',
    defaultMessage: 'None',
  },
  withEmployees: {
    id: 'app.components.AppPermissions.withEmployees',
    defaultMessage: 'To Employeees',
  },
  withAllMembers: {
    id: 'app.components.AppPermissions.withAllMembers',
    defaultMessage: 'To All Members',
  },
  confirmDeleteException: {
    id: 'app.components.AppPermissions.confirmDeleteException',
    defaultMessage: 'Remove custom permissions for {accountName}?',
  },
});
